/**
 * Created by 1 on 2016/12/23.
 */
'use strict';
/**
 * 线状图层分布基类
 * @module LineLayer
 */
define([
    './DistributeLayer',
    '../utils/CommonUtil',
    '../utils/LoggerUtil',
    '../g2'
], function (
    DistributeLayer,
    CommonUtil,
    LoggerUtil,
    g2
) {
    /**
     * 构造方法
     * @constructor
     * @classdesc 线图层
     * @augments G.lys.DistributeLayer
     * @alias G.lys.LineLayer
     * @param {Object} options - 必填，构造参数；
     * @param {G.Map/g2.carto.Map} options.map -必填，地图对象
     * @param {String} options.layerId - 可选，图层id，默认为随机字符串
     * @param {String} options.idKey - 必填，数据记录中作为唯一标识的字段名
     * @param {String} options.attributeField - 可选，数据记录中属性信息挂接的属性名，默认为空
     * @param {String} options.geometryField - 可选，数据记录中空间属性名，默认为空，如果有值，则几何使用数据记录中对应的坐标信息；
     * @param {Object} options.symbolConfig - 必填，符号配置
     * @param {String} options.defaultSymbolKey - 可选，符号配置文件中默认符号的key值，默认为default
     * @param {Number} options.spatialReference - 可选，图层坐标系，默认4326
     * @param {Number} options.dataSpatialReference - 可选，叠加数据的坐标系，默认图层坐标系
     * @param {Function} options.symbolUpdateCallback - 可选，地图显示的符号更新时的回调，
     * @param {Object} options.callbackContext - 可选，回调的上下文
     * @returns {Class} - 实例化的对象
     */
    var layer = DistributeLayer.extend({
        options: {
            symbolConfig: false//默认配置
        },
        initialize: function (options) {
            //没有坐标的数据
            this.noneSpatialArr = [];
            //显示的元素
            this.elements = [];
            //
            DistributeLayer.prototype.initialize.call(this, options);
        },
        /**
         * 添加监听
         * @private
         */
        _addListeners: function () {
            //do parent first
            DistributeLayer.prototype._addListeners.call(this);
            //
            this.map.listen("resolutionchanged", this._getZoomChangeLisener());
        },
        /**
         * 移除监听
         * @private
         */
        _removeListeners: function () {
            this.map.off("resolutionchanged", this._getZoomChangeLisener());
            //do parent last
            DistributeLayer.prototype._removeListeners.call(this);
        },
        /**
         * 获取比例尺变化监听
         * @returns {layer.mapClickHandler|*}
         * @private
         */
        _getZoomChangeLisener: function () {
            if (!this._zoomChangeLisener) {
                var self = this;
                //
                this._zoomChangeLisener = function (event) {
                    self.updateSymbol(event.level);
                }
            }
            return this._zoomChangeLisener;
        },
        /**
         * 批量添加线
         * @method
         * @memberOf G.lys.LineLayer.prototype
         * @param {Array} dataArr - 必填，数据数组
         * @param {Object} options - 可选
         * @param {Number} options.dataSpatialReference - 可选，数据的坐标系，默认为图层的坐标系
         */
        addElements: function (dataArr,options) {
            if (!CommonUtil.isArray(dataArr)) {
                LoggerUtil.error('dataArr is not an array');
                return;
            }
            options=options||{};
            //
            var zoom = this.map.getZoomLevel();
            //坐标不正确的数据
            var spatialReference=this.options.spatialReference,
                dataSpatialReference=options.dataSpatialReference||
                    this.options.dataSpatialReference;
            //
            for (var i = 0, len = dataArr.length; i < len; i++) {
                var data = dataArr[i];
                var polyline = this._getGeometry(data, dataSpatialReference,spatialReference);
                if (!polyline) {
                    this.noneSpatialArr.push(data);
                    continue;
                }
                var symbolObj = this._getSymbol(data, zoom),
                    elementId=this._getRecordId(data);
                var ele = new g2.sfs.Element({
                    id: elementId,
                    geometry: polyline,
                    symbol: symbolObj.symbol
                });
                //保存数据
                ele._data = data;
                //当前符号的比例尺级别范围；
                ele._zoomRange = symbolObj.zoomRange;
                //保存当前符号的symbolkey
                ele._symbolKey=symbolObj.symbolKey;
                //保存添加的元素
                this.elements.push(ele);
                //添加到图层
                this.layer.add(ele);
            }
            //notify symbol updated
            this._onSymbolsUpdated();
            //notify elements changed
            this._onElementChanged();
        },
        /**
         * 获取几何对象
         * @method
         * @memberOf G.lys.LineLayer.prototype
         * @param {Object} data
         * @param {Number} srcSpatialReference - 叠加的坐标系
         * @param {Number} destSpatialReference - 数据源坐标系
         * @returns {Object|null}
         */
        getGeometry:function(data,srcSpatialReference,destSpatialReference){
            if (!data) {
                return null;
            }
            var geometryObj = data[this.options.geometryField], geometry = null;
            try {
                if (typeof geometryObj == 'string') {
                    geometryObj = this.wktReader.read(geometryObj).toString();
                    geometry = g2.sfs.GeometryFactory.createGeometryFromWkt(geometryObj, srcSpatialReference);
                } else {
                    geometry = g2.sfs.GeometryFactory.createGeometryFromGeoJson(geometryObj, srcSpatialReference);
                }
            } catch (e) {
            }
            //需要转换坐标系
            if(srcSpatialReference&&destSpatialReference&&srcSpatialReference!=destSpatialReference){
                geometry=this.projService.transform(geometry,destSpatialReference);
            }
            return geometry;
        }
    });
    /**
     * 定义图层类型
     */
    Object.defineProperty(layer,'type',{
        value:21,
        configurable:false,
        writable:false
    });
    return layer;
});
